import React from 'react'
import Auth from '../../Auth'
import FormPage from '../FormPage'
import { Img } from "react-image";
import { Helmet } from "react-helmet";
import LoadingSpinner from "../../components/LoadingSpinner";
import SSOAuthorizationButtons from "../../components/SSOAuthorizationButtons";
import {Divider, Input} from "antd";
import {FormInputComponent} from "../../components/form/Form";

export default class AuthLogin extends FormPage {
    // Login form class
    static BGClass = 'login-form [&>.form-container]:py-0';

    // The nav path for this view
    static path = '/login';

    /**
     * The title shown on the form
     */
    static FormTitle = "auth.login.title";

    /**
     * The subtitle shown on the form
     */
    static FormSubtitle = "";

    /**
     * Show asterisk next to required fields
     */
    static ShowRequired = false;
    /**
     * The submit button title for the form
     */
    static FormSubmit = "auth.login.submit_button";

    /**
     * @returns {String | Array}
     */
    formTitle()
    {
        return 'Log in to continue'
        // let loginTitle = super.formTitle();
        // if (!this.state.loginMethod) {
        //     return 'Log in to continue'
        // }
        //
        // return loginTitle;
    }

    /**
     * @returns {String | Boolean | Object}
     */
    formSubmit()
    {
        let submitTitle = super.formSubmit();
        if (!this.state.loginMethod) {
            return 'Continue'
        }

        return submitTitle;
    }
    /**
     * The config for the optional footer
     *
     * @var {Object}
     */
    static ShowFooter = false;

    constructor(props) {
        super(props);
        if (localStorage.getItem('prev_session')) {
            try {
                let prevSession = JSON.parse(localStorage.getItem('prev_session'))
                if (prevSession?.loginMethod) {
                    this.state = {
                        ...this.state,
                        loginMethod: prevSession.loginMethod,
                        model: {
                            ...(this.state.model || {}),
                            email: prevSession?.email || ''
                        }
                    }

                }
            }catch (err) {
                console.warn('Error getting previous session', err)
            }
        }
    }
    /**
     * The fields mapping for the form
     */
    static FormFields = {
        email: {
            type: 'email',
            label: 'auth.login.email_label',
            required: true,
            autoComplete: 'email'
        },
        password: {
            type: 'password',
            required: true,
            label: 'auth.login.password_label',
        },
        // remember_me: {
        //     type: 'checkbox',
        //     label: 'auth.login.remember_label',
        //     required: false
        // },
    };

    showFullForm = () => {
        return this.state.loginMethod?.method === 'form'
    }
    /**
     * @returns {Object | Array}
     */
    formFields()
    {
        let fields = {
            email: <FormInputComponent
                value={this.state.model?.email || ''}
                fieldName="email"
                type="antd-input"
                required
                maxLength={255}
                invalidStyles={{bottom: -10}}
            >
                <Input
                    type="email"
                    autoComplete="email"
                    className={this.showFullForm() ? '[&_input]:cursor-not-allowed' : ''}
                    readOnly={this.showFullForm()}
                    addonAfter={(this.state.loginMethod && this.showFullForm()) ? <i className="clickable fa fa-edit" onClick={async () => {
                        console.log('click, removeingn')
                        await localStorage.removeItem('prev_session')
                        this.setState({loginMethod: null, model: {email: '',password: ''}});

                    }}/> : null}
                />

            </FormInputComponent>,
            // remember_me: {
            //     type: 'checkbox',
            //     label: 'auth.login.remember_label',
            //     required: false
            // },
        }
        if (this.showFullForm()) {
            // fields.email.disabled = true;
            // fields.email.addOnAfter = (
            //     <i className="clickable fa fa-edit" onClick={() => this.setState({loginMethod: null})}></i>
            // )
            fields = {
                ...fields,
                password: {
                    type: 'password',
                    required: true,
                    label: 'auth.login.password_label',
                },
            }
        }
        return this.transFormFields(
            fields
        );
    }
    /**
     * The links mapping for the form
     */
    static FormLinks = [
        {
            path: '/password/forgot',
            title: 'auth.login.password_help_link',
        }
    ];

    componentDidMount() {
        super.componentDidMount();
        if (laravel.oauth_error === 'No user found') {

            TB.alert('error',
                'No user found.',
                'There was an error while trying to authenticate you. ' +
                'There was no account found matching your SSO Provider. Please try again or contact your administrator for assistance.',
                [{title: 'Ok'}]);
            laravel.oauth_error = null;
        }
    }

    /**
     * Whether or not an alert should show if the user tries to navigate to another page or close the browser
     *
     * @var {Boolean}
     */
    static ShowsUnloadWarning = false;

    /**
     * The max width in pixels for the form container
     *
     * @var {Integer}
     */
    static MaxWidth = 800;

    /**
    * Handles form submit button clicks when form is valid
    *
    * @param {Object} creds
    * @returns void
    */
    async onSubmit(creds) {
        // TB.log().object(
        // 	'Login @ onSubmit', { ...creds }
        // );
        let isDisabled = true;
        await this.promisedState({ isDisabled });

        try {
            if (!this.state.loginMethod) {
                let response = await Auth.checkBeforeLogin(creds);
                if (response) {
                    let {method, redirect, sso_provider} = response;

                    // if (!TB.isProdEnv()) {
                        await localStorage.setItem('prev_session', JSON.stringify({loginMethod: response, email: creds.email}));
                    // }
                    if (method === 'form') {
                        await this.promisedState({loginMethod: response, isDisabled: false});


                        return;
                    }else if (redirect) {
                        window.location.href = redirect;
                    }
                }
            }else {
                let user = await Auth.login(creds);
            }
            isDisabled = false;
        } catch (e) {
            console.warn(e);
            TB.showServerErrorToast();
            isDisabled = false;
        }

        return this.promisedState({ isDisabled })
    }


    /**
     * Overridable method for rendering any form child elements
     *
     * @returns {Component}
     */

    renderFormView() {
        const logoDisplayClass = laravel.platform_settings.Show_Logo_On_Login_Page === true ? '' : 'hidden';

        return (
            <>
                <Helmet>
                    <title>Login | Wripple</title>
                </Helmet>
                <div className="mt-16 mb-20 px-4 py-16 m-auto bg-white sm:px-14 md:w-10/12 xl:w-9/12 ">
                    <div className="items-center lg:flex">
                        <div className="px-4 lg:w-1/2">
                            <div className="flex items-center flex-col lg:mb-5">
                                <h6 className="text-xs md:text-base">welcome to</h6>
                                <Img
                                    loader={(
                                        <div className={`flex flex-col items-center justify-center ${logoDisplayClass}`}>
                                            <LoadingSpinner />
                                        </div>
                                    )}
                                    src={[TB.logoBrandImagePath(), '/images/logo.png']}
                                    className={`w-36 md:w-48 ${logoDisplayClass}`}
                                />
                            </div>
                            <div className="w-full m-auto hidden md:block">
                                <img
                                    className="w-full px-12"
                                    src={laravel.platform_settings.Asset_Login_Graphic} alt={`Welcome to ${laravel.platform_name}`}
                                />
                            </div>
                        </div>

                        <div className="px-4 lg:w-1/2 self-start pt-12">


                            {this.renderForm()}

                            {/*this.state.loginMethod && (
                                <React.Fragment>
                                    <Divider plain className="my-2">Or continue with:</Divider>

                                    <div className="mb-3 flex flex-row items-center justify-center gap-3">
                                        <SSOAuthorizationButtons/>
                                    </div>

                                </React.Fragment>
                            )*/}
                        </div>
                    </div>
                </div>
            </>

        );
    }
}